(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 992px)');
  const DESKTOP_ZOOM_SIZE = 1000; // 1000x1000 on desktop

  function withShopifySize(url, size) {
    if (!url) return url;

    // Don’t double-append if it’s already sized
    if (/[?&]width=\d+/i.test(url) || /_[0-9]+x[0-9]+(?=\.)/i.test(url)) {
      return url;
    }

    // Shopify CDN supports width/height params (works well with .png/.jpg and keeps it deterministic)
    const hasQuery = url.indexOf('?') > -1;
    const joiner = hasQuery ? '&' : '?';

    // Square crop; if crop is unsupported for the specific URL, Shopify will still respect width.
    return `${url}${joiner}width=${size}&height=${size}&crop=center`;
  }

  function ensureLightbox() {
    let dlg = document.querySelector('.wd-lightbox');
    if (dlg) return dlg;

    dlg = document.createElement('dialog');
    dlg.className = 'wd-lightbox';
    dlg.innerHTML = `
      <div class="wd-lightbox__inner">
        <button class="wd-lightbox__close" type="button" aria-label="Close">×</button>
        <div class="wd-lightbox__overlay wd-diagram-alt-overlay" hidden></div>
        <img class="wd-lightbox__img" alt="">
      </div>
    `;
    document.body.appendChild(dlg);

    dlg.addEventListener('click', (e) => {
      const inner = dlg.querySelector('.wd-lightbox__inner');
      if (!inner || !inner.contains(e.target)) {
        dlg.close();
      }
    });

    const closeBtn = dlg.querySelector('.wd-lightbox__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => dlg.close());
    }

    return dlg;
  }

  function getZoomUrlFromImg(img) {
    const zoomHost = img.closest('product-gallery-zoom');
    if (zoomHost && zoomHost.dataset && zoomHost.dataset.zoom) {
      return zoomHost.dataset.zoom;
    }
    return img.currentSrc || img.src;
  }

  // Ensure hover-zoom uses a strong desktop image too
  function upgradeHoverZoomUrls() {
    if (!DESKTOP_MQ.matches) return;

    document.querySelectorAll('product-gallery-zoom[data-zoom]').forEach((el) => {
      const current = el.getAttribute('data-zoom');
      const next = withShopifySize(current, DESKTOP_ZOOM_SIZE);
      if (next && next !== current) {
        el.setAttribute('data-zoom', next);
      }
    });
  }

  // Optional: force higher hover zoom globally (leave OFF unless you want it)
  // function forceZoomScale(scale) {
  //   document.querySelectorAll('product-gallery-zoom').forEach((el) => {
  //     el.setAttribute('scale', String(scale));
  //   });
  // }

  function openLightboxFromImg(img) {
    const dlg = ensureLightbox();
    const modalImg = dlg.querySelector('.wd-lightbox__img');
    const overlay = dlg.querySelector('.wd-lightbox__overlay');

    if (!modalImg) return;

    let bigUrl = getZoomUrlFromImg(img);

    // Desktop: force the popup image to 1000x1000
    if (DESKTOP_MQ.matches) {
      bigUrl = withShopifySize(bigUrl, DESKTOP_ZOOM_SIZE);
    }

    modalImg.src = bigUrl;
    modalImg.alt = img.alt || '';

    const alt = (modalImg.alt || '').trim();
    if (overlay) {
      if (alt.charAt(0) === '#') {
        overlay.textContent = alt;
        overlay.hidden = false;
      } else {
        overlay.textContent = '';
        overlay.hidden = true;
      }
    }

    // Guard: some browsers block <dialog> showModal in certain contexts
    try {
      if (typeof dlg.showModal === 'function') {
        if (!dlg.open) dlg.showModal();
      } else {
        // Fallback if dialog unsupported
        window.open(bigUrl, '_blank', 'noopener');
      }
    } catch (err) {
      // Last-resort fallback
      window.open(bigUrl, '_blank', 'noopener');
    }
  }

  // Init + keep in sync on resize/orientation change
  function init() {
    upgradeHoverZoomUrls();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  window.addEventListener('resize', () => {
    // Only needed when crossing breakpoint, but cheap enough
    upgradeHoverZoomUrls();
  });

  document.addEventListener('click', (e) => {
    const img = e.target.closest('.\\#product-gallery-stage img.\\#media-image');
    if (!img) return;

    openLightboxFromImg(img);
  });

  // Uncomment if you want stronger hover zoom:
  // forceZoomScale(2.5);
})();

(function () {
  function stripUSDFromSchematicPrices(root = document) {
    root.querySelectorAll('.multiple_products_wrapper_schematic .mpv2-price .money').forEach((el) => {
      const t = (el.textContent || '').trim();
      const next = t.replace(/\s*USD\s*$/i, '').trim();
      if (next !== t) {
        el.textContent = next;
      }
    });
  }

  if (document.readyState !== 'loading') {
    stripUSDFromSchematicPrices();
  } else {
    document.addEventListener('DOMContentLoaded', () => stripUSDFromSchematicPrices());
  }

  const mo = new MutationObserver(() => stripUSDFromSchematicPrices());
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();